module.exports = __webpack_public_path__ + "assets/img/order_del.21900870.png";